import './Footer.style.scss';

import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// import hthLogo from "../../../Assets/hth_logo.png";
import { Link } from 'react-router-dom';

import { selectLang } from '../../../Contexts/lang/langueSlice';
import LogoLight from '../../../data/LogoLight';
import useWindowSize from '../../../hooks/useWindowSize';

function FooterConsulting({ styleProps }) {
    FooterConsulting.propTypes = {
        styleProps: PropTypes.any,
    };
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const lang = useSelector(selectLang);
    return (
        <footer
            style={styleProps}
            className="footer"
        >
            {device=='desktop' &&
                <>
                    <ul
                        className="r-footer"
                        style={{gap:'none',width:'50%'}}
                    >
                        <li style={{textAlign:'center'}}>
                            <h6 className='text-gold'>
                                {i18n.t('High Tech Hires')}
                            </h6>
                            <ul
                                className="box"
                                style={{width:'100%'}}
                            >
                                <li><a href={`/ConsultingServices?lang=${lang}`}>{i18n.t('Nos Services')}</a></li>
                                <li><a href={`/WhyHtHConsulting?lang=${lang}`}>{i18n.t('Pourquoi HTH')}</a></li>
                                <li><a href={`/AboutUsConsulting?lang=${lang}`}>{i18n.t('Qui sommes Nous')}</a></li>
                            </ul>
                        </li>
                        <li style={{textAlign:'center'}}>
                            <h6 className='text-gold'>
                                {i18n.t('Ressources')}
                            </h6>
                            <ul
                                className="box"
                                style={{width:'100%'}}
                            >
                                {/*<li><a href="/#">Aide et FAQ </a></li>*/}
                                <li><a href="/Consultingblogs">{i18n.t('Blog')}</a></li>
                                {/*<li><a href="/#">Programmes d’affiliation</a></li>*/}
                                {/*<li><a href="/#">Sitemap </a></li>*/}
                            </ul>
                        </li>
                        <li style={{textAlign:'center'}}>
                            <h6 className='text-gold'>
                                {i18n.t('Follow us')}
                            </h6>
                            <ul
                                className="box"
                                style={{width:'100%'}}
                            >
                                <li>
                                    <a
                                        href="https://www.instagram.com/hightechhires/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{i18n.t('Instagram')}</a></li>
                                <li>
                                    <a
                                        href="https://www.linkedin.com/company/high-tech-hires/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{i18n.t('Linkedin')}</a></li>
                            </ul>
                        </li>
                    </ul>
                    <div className='vectorParent'>
                        <svg
                            className="vector"
                            style={{borderColor:'#007D37'}}
                        >
                            <rect />
                        </svg>
                        <div className="b-footer d-flex justify-content-around copyrights" >
                            <Link to="/" >
                                <LogoLight />
                            </Link>
                            <div>                   </div>
                            <p style={{color:'white'}}>
                                {i18n.t('High Tech Hires © 2025. Tous droits réservés')}
                            </p>
                            <a
                                href={`privacyPolicy?lang=${lang}`}
                                style={{color:'white'}}
                            >
                                {i18n.t('Politique de Confidentialité')}
                            </a>
                            <a
                                href={`termsOfService?lang=${lang}`}
                                style={{color:'white'}}
                            >
                                {i18n.t('Conditions de Services')}
                            </a>
                        </div>
                    </div>
                </>
            }
            {device!='desktop' &&
            <>
                <Accordion style={{background:'rgb(0, 94, 35)',width:'100%'}}>
                    <AccordionSummary
                    //expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography><h6 className='text-gold'>
                            {i18n.t('High Tech Hires')}
                        </h6></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>

                            <ul className="box">
                                <li><a href={`/ConsultingServices?lang=${lang}`}>{i18n.t('Nos Services')}</a></li>
                                <li><a href={`/WhyHtHConsulting?lang=${lang}`}>{i18n.t('Pourquoi HTH')}</a></li>
                                <li><a href={`/AboutUsConsulting?lang=${lang}`}>{i18n.t('Qui sommes Nous')}</a></li>
                            </ul>

                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion style={{background:'rgb(0, 94, 35)',width:'100%'}}>
                    <AccordionSummary
                    //expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography><h6 className='text-gold'>
                            {i18n.t('Ressources')}
                        </h6></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>

                            <ul className="box">
                                {/*<li><a href="/#">Aide et FAQ </a></li>*/}
                                <li><a href="/Consultingblogs">{i18n.t('Blog')}</a></li>
                                {/*<li><a href="/#">Programmes d’affiliation</a></li>*/}
                                {/*<li><a href="/#">Sitemap </a></li>*/}
                            </ul>

                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion style={{background:'rgb(0, 94, 35)',width:'100%'}}>
                    <AccordionSummary
                    //expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography><h6 className='text-gold'>
                            {i18n.t('Follow us')}
                        </h6></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>

                            <ul className="box">
                                <li>
                                    <a
                                        href="https://www.instagram.com/hightechhires/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{i18n.t('Instagram')}</a></li>
                                <li>
                                    <a
                                        href="https://www.linkedin.com/company/high-tech-hires/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{i18n.t('Linkedin')}</a></li>
                            </ul>

                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <div className='vectorParent'>
                    <svg
                        className="vector"
                        style={{borderColor:'#007D37'}}
                    >
                        <rect />
                    </svg>
                    <div
                        className="b-footer d-flex justify-content-around copyrights op-footer"
                        style={{flexDirection:device=='destop'?'row':'column',gap:device=='destop'?'0':'16px',alignItems:'center'}}
                    >
                        <Link to="/" >
                            <LogoLight />
                        </Link>
                        <div style={{display:'flex',flexDirection:'row',gap:'16px',alignSelf:'center'}}>
                            <a
                                href={`privacyPolicy?lang=${lang}`}
                                style={{color:'white'}}
                                className='op-footer'
                            >
                                {i18n.t('Politique de Confidentialité')}
                            </a>
                            <svg
                                width="1"
                                height="14"
                                viewBox="0 0 1 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.5 1L0.500001 13"
                                    stroke="#002FAC"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <a
                                href={`termsOfService?lang=${lang}`}
                                style={{color:'white'}}
                                className='op-footer'
                            >
                                {i18n.t('Conditions de Services')}
                            </a>
                        </div>
                        <p style={{color:'white'}}>
                            {i18n.t('High Tech Hires © 2025.  Tous droits réservés')}
                        </p>
                    </div>
                </div>

            </>
            }
        </footer>
    );
}

export default FooterConsulting;

